import { useSelector } from 'react-redux'
import type { RouteComponentProps } from 'react-router-dom'

import EmptyState from 'components/Shared/EmptyState'
import Loading from 'components/Shared/Loading'
import { getCurrentUser } from 'ducks/users/index'
import type { User } from 'ducks/users/index'

import { AccountGoogleConnection } from '../Account/AccountGoogleConnection'

type MatchParams = {
  appId?: string
}

/**
 * Sign-in methods and linked identities (e.g. Google).
 */
export default function Connections({
  match,
}: RouteComponentProps<MatchParams>): JSX.Element {
  const user = useSelector(getCurrentUser) as User | null
  const { appId } = match.params

  const profileSettingsPath =
    typeof appId === 'string' && appId.length > 0
      ? `/apps/${appId}/screens/settings/account`
      : '/settings/account'

  if (!user) {
    return (
      <EmptyState greedy>
        <Loading />
      </EmptyState>
    )
  }

  return (
    <div className="account-settings">
      <h3 className="settings-header">Linked Accounts</h3>
      <p
        style={{ color: '#666', fontSize: 14, marginBottom: 24, maxWidth: 560 }}
      >
        Manage how you sign in to Adalo. Connect Google to use one-click login,
        or disconnect it after you set a password on your profile.
      </p>
      <AccountGoogleConnection
        user={user}
        profileSettingsPath={profileSettingsPath}
      />
    </div>
  )
}
